import styled from 'styled-components';
import { Typography } from '../Typography/Typography';
import { shortErrorCopy } from '../../sharedCopy';

export const StandardErrorToast = () => <Toast variant="error">{shortErrorCopy}</Toast>;

type ToastVariant = 'default' | 'error' | 'success';

const StyledToast = styled.div<{ $variant: ToastVariant }>`
  padding: 0.75rem 1rem;
  border-radius: var(--border-radius-medium);
  width: fit-content;
  border-width: 1px;
  border-style: solid;

  ${({ $variant }) => {
    if ($variant === 'error') {
      return `
        // one-off red color lighter than light-red
        // TODO(tokens): Replace hex color value #ffd1d2 with numbered equivalent once available.
        background-color: #ffd1d2;
        // TODO(tokens): Replace hex color value #ffd1d2 with numbered equivalent once available.
        border-color: #ffd1d2;
        `;
    } else if ($variant === 'success') {
      return `        
        // one-off red color lighter than light-red
        // TODO(tokens): Replace hex color value #d4f0e1 with numbered equivalent once available.
        background-color: #d4f0e1;
        // TODO(tokens): Replace hex color value #d4f0e1 with numbered equivalent once available.
        border-color: #d4f0e1;
      `;
    } else {
      return `
        // default variant
        background-color: var(--grayscale-900);
        border-color: var(--grayscale-900);
      `;
    }
  }}
`;

const ToastChildren = styled(Typography)<{ $variant: ToastVariant }>`
  color: ${({ $variant }) => {
    if ($variant === 'error') {
      return 'var(--red-800)';
    } else if ($variant === 'success') {
      return 'var(--green-800)';
    } else {
      return 'var(--surface-100)';
    }
  }};
`;

export type ToastProps = {
  children: React.ReactNode;
  className?: string;
  variant?: ToastVariant;
};

/**
 * A custom toast. Intended to be used with react-hot-toast.
 *
 * Example usage:
 * import toast from "react-hot-toast";
 * [...]
 * onClick={() => toast.custom(() => <Toast>A very important message</Toast>)}
 */
export const Toast = ({ children, className, variant = 'default' }: ToastProps) => {
  return (
    <StyledToast className={className} $variant={variant}>
      <ToastChildren styledAs="bodySmallSpaceGrotesk" weight={500} $variant={variant}>
        {children}
      </ToastChildren>
    </StyledToast>
  );
};
